import { Speaker, SpeakersResponse } from './types';

export interface ReshapedSpeakers {
    [key: string]: Speaker;
}

type SpeakersInSession = {
    role?: string;
    speakerId: number;
}[];

export const reshapeSpeakersToObj = (speakers: SpeakersResponse): ReshapedSpeakers => {
    return speakers?.reduce(
        (
            speakersObjs,
            {
                id,
                firstname,
                lastname,
                prefix,
                company,
                title,
                thumbnailSet,
                thumbnailUrl,
                email,
                bio,
            }
        ) => {
            speakersObjs[id] = {
                id,
                firstName: firstname,
                lastName: lastname,
                prefix,
                company,
                title,
                thumbnailSet,
                thumbnailUrl,
                email,
                bio,
            };

            return speakersObjs;
        },
        {}
    );
};

export const mapSpeakersById = (
    speakers: SpeakersInSession,
    reshapedSpeakers: ReshapedSpeakers
): Speaker[] => {
    const validSpeakerOnly = ({ speakerId }) => reshapedSpeakers[speakerId];
    const hydrateSpeakers = ({ speakerId, role }) => ({ ...reshapedSpeakers[speakerId], role });
    return speakers.filter(validSpeakerOnly).map(hydrateSpeakers);
};
